window.xgenQueryId = window.xgenQueryId || {};
function hashCode(str) {
  if (str.length % 32 > 0) str += Array(33 - str.length % 32).join("z");
  var hash = '', bytes = [], i = 0, j = 0, k = 0, a = 0, dict = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  for (i = 0; i < str.length; i++) {
    ch = str.charCodeAt(i);
    bytes[j++] = (ch < 127) ? ch & 0xFF : 127;
  }
  var chunk_len = Math.ceil(bytes.length / 32);
  for (i = 0; i < bytes.length; i++) {
    j += bytes[i];
    k++;
    if ((k == chunk_len) || (i == bytes.length - 1)) {
      a = Math.floor(j / k);
      if (a < 32)
        hash += '0';
      else if (a > 126)
        hash += 'z';
      else
        hash += dict[Math.floor((a - 32) / 2.76)];
      j = k = 0;
    }
  }
  return hash;
}
const minute = 60 * 1000

class CustomXGen {
  constructor() {
    this.key = window.xgen_vars.xgen_api_key
    this.secret = window.xgen_vars.xgen_api_secret
    this.clientId = window.xgen_vars.xgen_client_id
    this.trackerId = window.xgen_vars.xgen_tracker_id
    this.collectionDeploymentId = window.xgen_vars.xgen_collection_deployment_id
    this.searchDeploymentId = window.xgen_vars.xgen_search_deployment_id
    this.locale = window.theme.locale
    this.xgenEvents = []
    this.isV3 = false
    this.trackingInitialized = false
    this.authStore = null
    const xgen_vars = window.xgen_vars || {}
    const marketLocale = 'en-' + xgen_vars.locale
    this.xgenCollection = (xgen_vars.locales && xgen_vars.locales.includes(marketLocale)) ? marketLocale : 'default'
    this.isSearchOrCollection = window.location.pathname.includes('search') || window.location.pathname.includes('collections/')
    this.recommendQueue = []

    const recommendQueueTime = this.isSearchOrCollection ? 1500 : 500
    const scheduleRecommendQueue = () => {
      if (!this.hasMarketingConsent()) return
      setTimeout(this.processRecommendQueue.bind(this), recommendQueueTime)
    }

    if (this.hasMarketingConsent()) {
      scheduleRecommendQueue()
    } else if (window.theme?.consentGating && window.lovisaConsent) {
      window.lovisaConsent.onConsentReady(scheduleRecommendQueue)
      window.addEventListener('lovisa:consent-updated', scheduleRecommendQueue)
    } else {
      scheduleRecommendQueue()
    }

    this.whenConsentReady(() => this.loadSdk())
    if (window.theme?.consentGating) {
      window.addEventListener('lovisa:consent-updated', () => {
        if (this.getStatisticsConsent() && this.xgen && !this.trackingInitialized) {
          this.initXgenTracking()
        }
      })
    }
  }

  whenConsentReady(fn) {
    if (window.theme?.consentGating && window.lovisaConsent) {
      window.lovisaConsent.onConsentReady(fn)
    } else {
      fn()
    }
  }

  getStatisticsConsent() {
    if (window.theme?.consentGating && window.lovisaConsent?.ready) {
      return window.lovisaConsent.hasStatistics()
    }
    try {
      return window.Shopify.customerPrivacy.userCanBeTracked()
    } catch (err) {
      // Consent tracking API not available
      return false
    }
  }

  hasMarketingConsent() {
    if (window.theme?.consentGating) {
      return window.lovisaConsent?.ready && window.lovisaConsent.hasMarketing()
    }
    return true
  }

  processRecommendQueue() {
    if (!this.hasMarketingConsent()) return
    const ids = JSON.parse(JSON.stringify(this.recommendQueue))
    this.recommendQueue = false
    if (ids.length) {
      this.recommend({ ids, queue: true }).then(results => {
        //console.log('xgen:recommendations:processed', results)
        window.dispatchEvent(new CustomEvent('xgen:recommendations:processed', { detail: results }))
      })
    }
  }
  loadSdk() {
    const xgenInstance = this
    window.Shopify.loadFeatures(
      [{
        name: "consent-tracking-api",
        version: "0.1",
      },],
      (error) => {
        //if (error) throw error;
        class CustomAuthStore extends XGenSdkCore.LocalCookieAuthStore {
          _originalGenerateUserId;

          constructor(...args) {
            super(...args);

            // Force custom key names regardless of SDK version / params nesting
            this.tokenKey = 'custom_xgen_token';
            this.userKey = 'custom_xgen_user';
            this.sessionKey = 'custom_xgen_session';

            this._originalGenerateUserId = this.generateUserId;

            this.generateUserId = () => {
              return xgenInstance.getStatisticsConsent()
                ? this._originalGenerateUserId()
                : `cookieless${new Date().toISOString().substring(0, 13)?.replace(/-/g, '')}`;
            };

          }

          _storageGet(key) {
            if (xgenInstance.getStatisticsConsent()) {
              return super._storageGet(key);
            }
            let val = localStorage.getItem(key);
            if (!val) val = sessionStorage.getItem(key);
            if (!val) return this.storageFallback ? this.storageFallback[key] : undefined;
            try {
              return JSON.parse(val);
            } catch {
              return val;
            }
          }

          _storageSet(key, val) {
            if (xgenInstance.getStatisticsConsent()) {
              super._storageSet(key, val);
              return;
            }
            if (key === this.sessionKey) {
              sessionStorage.setItem(key, JSON.stringify(val));
            } else {
              localStorage.setItem(key, JSON.stringify(val));
            }
            if (this.storageFallback) this.storageFallback[key] = val;
          }

          _storageRemove(key) {
            if (xgenInstance.getStatisticsConsent()) {
              super._storageRemove(key);
              return;
            }
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
            if (this.storageFallback) delete this.storageFallback[key];
          }

          get user() {
            const existingUser = super.user;

            if (!existingUser) return null;

            const isCookieless = existingUser.userId.startsWith('cookieless');
            const cookiesAccepted = xgenInstance.getStatisticsConsent()

            // Was cookieless, now accepted → clear so a real userId gets generated
            if (isCookieless && cookiesAccepted) {
              this.clear();

              // By returning null, generateUserId() will be called again
              return null;
            }

            // Was real userId, now rejected → clear so a cookieless id gets generated
            if (!isCookieless && !cookiesAccepted) {
              this.clear();

              // By returning null, generateUserId() will be called again
              return null;
            }

            return existingUser;
          }
        }

        if (!xgenInstance.getStatisticsConsent()) {
          xgenInstance.removeSdkDefaultCookies()
        }

        const authStore = new CustomAuthStore({ cookieOptions: { domain: '.' + window.location.hostname.replace('www.', '') } })
        xgenInstance.authStore = authStore
        const xgenOptions = { key: xgenInstance.key, secret: xgenInstance.secret, clientId: xgenInstance.clientId, trackerId: xgenInstance.trackerId, locale: xgenInstance.locale, authStore: authStore }
        xgenInstance.xgen = new XGenSdkCore.XGenClient(xgenOptions);
        document.dispatchEvent(new CustomEvent('xgen-sdk-loaded'));
        if (xgenInstance.getStatisticsConsent()) {
          xgenInstance.initXgenTracking()
        }
      }
    );
  }
  mapGTMEvent(event) {
    switch (event.event) {
      case 'pageView':
        return {
          action: "pageView",
          data: event.data || {}
        }

      case 'view_promotion':
        return false

      case 'productView':
      case 'itemView':
        console.log('ItemView event')
        return {
          action: "itemView",
          data: event.data || {
            item: {
              id: "",
              name: "",
              price: "",
              currency: "",
            }
          }
        }
      case 'categoryView':
        return {
          action: "categoryView",
          data: event.data || {
            category: "",
            items: [
              "id", "id"
            ]
          }
        }
      case 'addToCart':
        return {
          action: "addToCart",
          data: event.data || {
            item: {
              id: "",
              name: "",
              price: "",
              currency: "",
              quantity: "",
            }
          }
        }
      default:
        return { action: event.event, data: event.data || {} }

    }
  }
  pushEvent(event) {
    if (!this.getStatisticsConsent()) return
    if (this.trackingInitialized && this.xgen) {
      const mappedEvent = this.mapGTMEvent(event)
      if (mappedEvent && this.xgen.track[mappedEvent.action]) {
        this.xgen.track[mappedEvent.action](mappedEvent.data)
      }
      return
    }
    this.xgenEvents.push(event)
  }
  initXgenTracking() {
    if (!this.getStatisticsConsent() || !this.xgen || this.trackingInitialized) return
    this.trackingInitialized = true
    const xgBatchEvents = this.xgen.track.createBatch();
    xgBatchEvents.pageView();
    this.xgenEvents.forEach(event => {
      const mappedEvent = this.mapGTMEvent(event);
      console.log('XGen Track (Batch) ', mappedEvent);
      if (mappedEvent && xgBatchEvents[mappedEvent.action]) {
        console.log('SENDING: XGen Track (Batch) ', JSON.stringify(mappedEvent))
        xgBatchEvents[mappedEvent.action](mappedEvent.data);
      }
    });
    xgBatchEvents.send();

    this.pushEvent = (event) => {
      if (!this.getStatisticsConsent()) return
      const mappedEvent = this.mapGTMEvent(event)
      console.log('XGen Track ', mappedEvent)
      if (mappedEvent && this.xgen.track[mappedEvent.action]) {
        console.log('SENDING: XGen Track ', JSON.stringify(mappedEvent))
        return Promise.resolve(this.xgen.track[mappedEvent.action](mappedEvent.data))
      } else {
        console.log('XGen Track - No event found', mappedEvent)
        return Promise.resolve()
      }
    }
  }

  removeSdkDefaultCookies() {
    const names = ['xgen_session', 'xgen_token', 'xgen_user']
    names.forEach((name) => {
      window.theme.removeCookie(name)
      window.theme.removeCookie(name, window.location.host)
      window.theme.removeCookie(name, '.' + window.location.host)
      const hostSplit = window.location.host.split('.').slice(1).join('.')
      if (hostSplit) {
        window.theme.removeCookie(name, hostSplit)
        window.theme.removeCookie(name, '.' + hostSplit)
      }
    })
  }

  removeXgenCookies() {
    this.removeSdkDefaultCookies()
    window.theme.removeCookie('custom_xgen_session')
    window.theme.removeCookie('custom_xgen_token')
    window.theme.removeCookie('custom_xgen_user')
    window.theme.removeCookie('custom_xgen_session', window.location.host)
    window.theme.removeCookie('custom_xgen_token', window.location.host)
    window.theme.removeCookie('custom_xgen_user', window.location.host)
    window.theme.removeCookie('custom_xgen_session', '.' + window.location.host)
    window.theme.removeCookie('custom_xgen_token', '.' + window.location.host)
    window.theme.removeCookie('custom_xgen_user', '.' + window.location.host)
    const hostSplit = window.location.host.split('.').slice(1).join('.')
    if (hostSplit) {
      window.theme.removeCookie('custom_xgen_session', hostSplit)
      window.theme.removeCookie('custom_xgen_token', hostSplit)
      window.theme.removeCookie('custom_xgen_user', hostSplit)
      window.theme.removeCookie('custom_xgen_session', '.' + hostSplit)
      window.theme.removeCookie('custom_xgen_token', '.' + hostSplit)
      window.theme.removeCookie('custom_xgen_user', '.' + hostSplit)
    }
  }

  xgenLoaded() {
    return new Promise((resolve, reject) => {
      if (this.xgen) {
        resolve(this.xgen);
      } else {
        document.addEventListener('xgen-sdk-loaded', () => {
          resolve(this.xgen);
        });
      }
    })
  }

  prepareSearchInput(input) {
    if (!input.options.deploymentId) {
      if (this.collectionDeploymentId) {
        input.options.deploymentId = this.collectionDeploymentId
      } else if (this.searchDeploymentId) {
        input.options.deploymentId = this.searchDeploymentId
      } else {
        throw new Error('No deployment id provided')
      }
    }

    if (!input.query) {
      input.query = ''
    }

    const queryId = input.queryId && input.queryId.length > 0 ? input.queryId : false

    const options = { ...input.options }
    if (!options.collection) {
      options.collection = this.xgenCollection
    }

    //if (queryId === "main-results") options.facets = true
    options.facets = true

    if (queryId) return { query: input.query, queryId: queryId, options: { ...options, queryId: queryId } }
    return { query: input.query, options: options }
  }

  getTrendingSearches(input) {
    if (!input) input = {}
    if (!input.collection) {
      input.collection = this.xgenCollection
    }
    return new Promise((resolve, reject) => {
      this.xgenLoaded().then(xgen => {
        xgen.search.getTrendingSearches(input).then(resolve).catch(error => {
          this.removeXgenCookies()
          setTimeout(() => {
            xgen.search.getTrendingSearches(input).then(resolve)
          }, 0)
        })
      })
    })
  }
  getSearchSuggestions(input, devMode) {
    const query = typeof input === 'undefined' ? false : typeof input === 'string' ? input : typeof input === 'object' ? input.query : false
    if (!query) return Promise.resolve(false)
    input = typeof input === 'string' ? { query: query } : input
    if (!input.collection) {
      input.collection = this.xgenCollection
    }
    if (devMode) {
      if (!input.options) input.options = {}
      input.options.devMode = true
    }
    return new Promise((resolve, reject) => {
      this.xgenLoaded().then(xgen => {
        xgen.search.getSearchSuggestions(input).then(resolve).catch(error => {
          this.removeXgenCookies()
          setTimeout(() => {
            xgen.search.getSearchSuggestions(input).then(resolve)
          }, 0)
        })
      })
    })
  }

  search(input) {
    const timeNow = Date.now()
    const maxCacheTime = 5 * minute
    const queryObject = this.prepareSearchInput(input)
    if (!queryObject) return Promise.resolve(false);

    if (queryObject.queryId && this.xgen && typeof this.xgen.cancel === 'function') {
      this.xgen.cancel(queryObject.queryId)
    }
    const hash = 'xg_last_search'
    return new Promise((resolve, reject) => {
      const lastSearch = sessionStorage.getItem(hash) ? JSON.parse(sessionStorage.getItem(hash)) : {}
      Object.keys(lastSearch).forEach((lsKey) => {
        if (lastSearch[lsKey].timestamp + maxCacheTime <= timeNow) delete lastSearch[lsKey]
      })

      let thisMaxCacheTime = maxCacheTime
      while (Object.keys(lastSearch).length > 10 || JSON.stringify(lastSearch).length > 10000) {
        thisMaxCacheTime = thisMaxCacheTime - minute
        Object.keys(lastSearch).forEach((lsKey) => {
          if (lastSearch[lsKey].timestamp + thisMaxCacheTime <= timeNow) delete lastSearch[lsKey]
        })
      }
      const queryHash = hashCode(JSON.stringify(queryObject))
      if (lastSearch && lastSearch[queryHash] && lastSearch[queryHash].timestamp && lastSearch[queryHash].timestamp + maxCacheTime > timeNow) {
        lastSearch[queryHash].isFromCache = true
        resolve(lastSearch[queryHash])
      } else {
        this.xgenLoaded().then(xgen => {
          xgen.search.getResults(queryObject).then(results => {
            if (results) {
              if (results.total_result !== undefined && results.totalResults === undefined) results.totalResults = results.total_result;
              if (results.products_list !== undefined && results.items === undefined) results.items = results.products_list;
              if (results.url_redirect && !results.urlRedirect) results.urlRedirect = results.url_redirect;
            }
            results.timestamp = Date.now()
            lastSearch[queryHash] = results
            try {
              sessionStorage.setItem(hash, JSON.stringify(lastSearch))
            } catch (error) {
            }
            resolve(results)
          }).catch(error => {
            this.removeXgenCookies()
            setTimeout(() => {
              xgen.search.getResults(queryObject).then(results => {
                if (results) {
                  if (results.total_result !== undefined && results.totalResults === undefined) results.totalResults = results.total_result;
                  if (results.products_list !== undefined && results.items === undefined) results.items = results.products_list;
                  if (results.url_redirect && !results.urlRedirect) results.urlRedirect = results.url_redirect;
                }
                results.timestamp = Date.now()
                lastSearch[queryHash] = results
                try {
                  sessionStorage.setItem(hash, JSON.stringify(lastSearch))
                } catch (error) {
                  // Session storage error
                }
                resolve(results)
              })
            }, 0)
          })
        })
      }
    })
  }

  recommend(input) {
    if (!this.hasMarketingConsent()) {
      if (input && input.ids && this.recommendQueue) {
        this.recommendQueue.push(...input.ids)
      }
      return Promise.resolve({});
    }
    if (!input.ids || input.ids.length === 0) return Promise.resolve({});
    input.ids = [...new Set(input.ids)]
    return new Promise((resolve, reject) => {
      if (Object.keys(input).length === 1 && input.ids && this.recommendQueue) {
        this.recommendQueue.push(...input.ids)
        window.addEventListener('xgen:recommendations:processed', (event) => {
          resolve(event.detail)
        }, { once: true })
      } else {
        if (input.queue) {
          this.recommendQueue = false
        }
        if (!input.ids) {
          throw new Error('No ids provided')
        }
        const xgenObject = { options: {} }
        const keys = ['pathname', 'queryString', 'exclude', 'recentlyViewed', 'productCode', 'targetProductCode']
        Array.from(keys).forEach(key => {
          if (typeof (input[key]) !== 'undefined') {
            xgenObject.options[key] = input[key]
          }
        })

        // v2 vs v3? different implementation
        if (this.isV3) {
          xgenObject.containerIds = input.ids
          xgenObject.options = { version: 'v3' }
        } else {
          xgenObject.elementIds = input.ids
        }

        xgenObject.options.locale = '/' + this.xgenCollection + '/'

        this.xgenLoaded().then(xgen => {
          xgen.recommend.getResults(xgenObject).then(results => {
            resolve(results)
          }).catch(error => {
            this.removeXgenCookies()
            setTimeout(() => {
              xgen.recommend.getResults(xgenObject).then(results => {
                resolve(results)
              })
            }, 0)
          })
        })
      }
    })

  }

  getRecentlyViewed(productId) {
    var recentlyViewed = localStorage.getItem("xgen_recentProducts") || "";
    if (productId && recentlyViewed) {
      // Split by pipe, filter out the current productId, and join back
      var recentlyViewedArray = recentlyViewed.split('|').filter(id => id.trim() != productId);
      recentlyViewed = recentlyViewedArray.join('|');
    }
    return recentlyViewed;
  }
  unifyProduct(product) {
    const tags = [];
    if (product.tags && typeof (product.tags) === "string") {
      tags.push(...product.tags.split(','));
    }
    if (product.tags && Array.isArray(product.tags)) {
      tags.push(...product.tags);
    }
    if (product.types && Array.isArray(product.types)) {
      tags.push(...product.types);
    }
    if (product.type && typeof (product.type) === 'string') {
      tags.push(product.type);
    }
    if (product.product_types && typeof product.product_types === 'string') {
      tags.push(...product.product_types.split(','));
    }
    if (product.product_types && Array.isArray(product.product_types)) {
      tags.push(...product.product_types);
    }
    const productUrl = product.product_url || product.link;
    const handle = product.handle || productUrl.split('/').pop().replace(/\?.*$/g, '');
    return {
      available: typeof (product.available) !== "undefined" ? product.available : typeof (product.is_in_stock) !== "undefined" ? product.is_in_stock === "1" : product.variants.some(variant => variant.available),
      id: product.prod_code || product.code,
      title: product.prod_name,
      description: product.description,
      price: product.sale_price && product.sale_price !== "None" ? product.sale_price * 100 : product.price * 100,
      compareAtPrice: product.price * 100,
      compare_at_price: product.price * 100,
      vendor: product.brand,
      handle: handle,
      url: productUrl,
      tags: tags,
      image: product.image,
      featured_image: product.image,
      images: product.images ? product.images : [product.image],
      _type: '',
      currency: {
        symbol: product.currency_symbol || product.price_currency_symbol,
        code: product.currency_code || product.price_currency
      },
      collections: product.collections ? product.collections.map(collection => {
        if (typeof collection === 'object' && collection !== null) {
          return {
            id: collection.id || collection.collection_id,
            handle: collection.handle,
            title: collection.title
          };
        }
        return {
          handle: collection
        };
      }) : [],
      options: product.options,
      has_only_default_variant: !product.variants || product.variants.length === 1,
      variants: product.variants ? product.variants.map(variant => ({
        id: variant.id || variant.variant_id,
        title: variant.title,
        url: variant.url,
        sku: variant.sku,
        available: variant.available,
        inStock: variant.is_in_stock === "1",
        onSale: variant.is_on_sale === "1",
        price: variant.sale_price && variant.sale_price !== "None" ? variant.sale_price * 100 : variant.price * 100,
        compareAtPrice: variant.price * 100,
        compare_at_price: variant.price * 100,
        options: variant.options || [],
        option1: variant.options?.[0]?.value || null,
        option2: variant.options?.[1]?.value || null,
        option3: variant.options?.[2]?.value || null
      })) : []
    };
  }
}
window.xgenCommon = new CustomXGen()
